import React from 'react';

import { DataTableProps } from './DataTable';
import DataTableFilter from './DataTableFilter';
import { getDataTableColumns, getDataTableFilters } from './DataTableMetadataHelpers';

export interface WithFilteringProps {
    initialValues?: any;
    updateData?: (data: any) => void | Promise<void>;
    updateFilter?: (filter: any) => void | Promise<void>;
}

export interface WithFilteringState<V> {
    filteredData?: V[];
}

export default <P extends DataTableProps<V>, V>(Component: React.ComponentType<P>) =>
    class WithFiltering extends React.Component<P & WithFilteringProps, WithFilteringState<V>> {
        ref: React.RefObject<DataTableFilter<V>>;

        constructor(props: Readonly<P>) {
            super(props);

            this.ref = React.createRef();

            this.state = {
                filteredData: this.props.data
            };
        }
        
        render() {
            const { children, data, initialValues, updateData, updateFilter, ...rest } = this.props;

            const columns = getDataTableColumns(children, data);
            const filters = getDataTableFilters(children, data);

            const thisRef = this.ref;

            const onDropdownShown = (event: any) => {
                const menu = $(event.target).find(".dropdown-menu");
        
                if (menu.length) {
                    const offset = menu.offset();
                    const width = menu.width() || 0;
                    const dropdownWidth = $(menu).closest(".dropdown").eq(0).width() || 0;
                    const container = $(menu).closest(".data-table-with-filter-container");
                    const containerOffset = container.offset();

                    if (containerOffset) {
                        const containerWidth = container.width() || 0;
                        const scrollLeft = $(document).scrollLeft();
                        const scrollTop = $(document).scrollTop();

                        if (offset && offset.left !== undefined && offset.top !== undefined && scrollLeft !== undefined && scrollTop !== undefined && containerWidth !== undefined) {
                            if (offset.left + width <= containerOffset.left + containerWidth) {
                                menu.css({
                                    left: "0px",
                                    top: "43px",
                                    position: "absolute",
                                    zIndex: 5000
                                });
                            } else {
                                menu.css({
                                    left: (dropdownWidth - width),
                                    top: "43px",
                                    position: "absolute",
                                    zIndex: 5000
                                })
                            }
                        }
                    }
                }
            };

            const onDropdownHidden = (event: any) => {
                $(event.target).find(".dropdown-menu").css({
                    left: "",
                    top: "",
                    position: "",
                    zIndex: ""
                });
            };

            return <div className="data-table-with-filter-container" ref={ref => {
                if (ref && thisRef.current) {
                    $(ref).find(".dropdown").on("shown.bs.dropdown", onDropdownShown);
                    $(ref).find(".dropdown").on("hidden.bs.dropdown", onDropdownHidden);
                }
            }}>
                <DataTableFilter<V> data={this.props.data} updateData={this.updateFilteredData.bind(this)} initialValues={this.props.initialValues} updateFilter={this.props.updateFilter} ref={thisRef}>{filters}</DataTableFilter>
                <Component data={this.state.filteredData} {...rest as any}>{columns}</Component>
            </div>;
        }

        updateFilteredData(data?: V[]) {
            this.setState({
                filteredData: data
            });

            if (this.props.updateData) {
                this.props.updateData(data);
            }
        }
    }
;